module.exports = __webpack_public_path__ + "img/sea-5.aeab8cc9.jpg";